module.exports = __webpack_public_path__ + "img/sceneca_10.bb4d6767.png";